
<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-toolbar color="" class="example-toolbar">
      <button id="btn" mat-icon-button (click)="snav.toggle()"></button>

      <h1 class="example-app-name">TYTUSX</h1>


    </mat-toolbar>

    <mat-sidenav-container class="example-sidenav-container"
                           [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
      <mat-sidenav class="matsnv" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
                   [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
        <mat-nav-list>
          <a mat-list-item [routerLink]="nav.route" *ngFor="let nav of fillerNav">
            <mat-icon class="icono">{{nav.icon}}</mat-icon> {{nav.name}}</a>

        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
